import { render, staticRenderFns } from "./invoiceDesign.vue?vue&type=template&id=20dd4f4f&scoped=true"
import script from "./invoiceDesign.vue?vue&type=script&lang=js"
export * from "./invoiceDesign.vue?vue&type=script&lang=js"
import style0 from "./invoiceDesign.vue?vue&type=style&index=0&id=20dd4f4f&prod&scoped=true&lang=css"
import style1 from "./invoiceDesign.vue?vue&type=style&index=1&id=20dd4f4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd4f4f",
  null
  
)

export default component.exports